import React from 'react';
import { MessageCircle, User } from 'lucide-react';
import { Link } from 'react-router-dom';
interface QAItemProps {
  id: string;
  userName: string;
  userInitials: string;
  question: string;
  questionDate: string;
  answer?: {
    text: string;
    date: string;
    sellerName: string;
  };
}
export function QAItem({
  userName,
  userInitials,
  question,
  questionDate,
  answer
}: QAItemProps) {
  return <div className="border border-gray-300 bg-white p-6" data-id="element-986">
      {/* Question */}
      <div className="flex items-start gap-3 mb-4" data-id="element-987">
        <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center font-bold text-xs" data-id="element-988">
          {userInitials}
        </div>
        <div className="flex-1" data-id="element-989">
          <div className="flex items-center gap-2 mb-1" data-id="element-990">
            <span className="font-bold text-sm" data-id="element-991">{userName}</span>
            <span className="text-xs text-gray-500 font-mono" data-id="element-992">
              asked on {questionDate}
            </span>
          </div>
          <p className="text-sm text-gray-700 font-medium" data-id="element-993">{question}</p>
        </div>
      </div>

      {/* Answer */}
      {answer ? <div className="pl-11 border-l-2 border-blue-200 bg-blue-50 p-4" data-id="element-994">
          <div className="flex items-center gap-2 mb-2" data-id="element-995">
            <span className="text-xs font-bold text-blue-900" data-id="element-996">
              Seller Response
            </span>
            <span className="text-xs text-blue-700 font-mono" data-id="element-997">
              {answer.date}
            </span>
          </div>
          <p className="text-sm text-gray-700" data-id="element-998">{answer.text}</p>
          <Link to="/seller/profile" className="text-xs text-blue-600 hover:underline mt-2 inline-block" data-id="element-999">
            View {answer.sellerName}'s profile →
          </Link>
        </div> : <div className="pl-11 text-xs text-gray-500 italic" data-id="element-1000">
          Waiting for seller response...
        </div>}
    </div>;
}